import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css'
import {nextTick, ref, watch, onMounted} from "vue";
import 'vant/es/uploader/style';
import wx from 'weixin-js-sdk';
import weChatUploadApi from "@/utils/Api/Upload";
import commMethods from "@/assets/ts/common";
import CONFIG from "../../../public/serverConfig";
import {showToast} from "vant";

interface Props {
  list: any,
  count: number,
  disabled: boolean,
  aspectRatio?: number,//默认值NaN , 可设置数字例如 1，  16 / 9
  id: string | number,
  isCrop: boolean,//裁剪模式
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadImage',
  props: {
    list: { default: [] },
    count: { default: 9 },
    disabled: { type: Boolean },
    aspectRatio: { default: NaN },
    id: {},
    isCrop: { type: Boolean, default: true }
  },
  emits: ["getImgList"],
  setup(__props: any, { emit: __emit }) {


onMounted(() => {
  commMethods.getTicket(['uploadImage']);


})

const props = __props
// 封装裁剪功能

const fileList = ref([
  // {
  //   url: 'https://fastly.jsdelivr.net/npm/@vant/assets/leaf.jpeg',
  //   status: 'success',
  //   // message: '上传中...',
  // },
  // {
  //   url: 'https://fastly.jsdelivr.net/npm/@vant/assets/tree.jpeg',
  //   // status: 'failed',
  //   // message: '上传失败',
  // },
]);

watch(() => props.list, (newval) => {


  let l = [];
  for (let i = 0; i < newval.length; i++)
    l.push({
      url: newval[i],
    })

  fileList.value = l;
})
//todo 向外抛值
const emit = __emit;
const show = ref(false);
const cutImgUrl = ref('');
const afterRead = (file: any) => {

  console.log(file.file)
  // let formData = new FormData();
  // formData.append('file', file.file);
  // weChatUploadApi.uploadFile(formData).then(res=>{
  //   console.log(res)
  //   emit('getImgList',props.list.concat(CONFIG.imgURL+res.data.filepath));
  //   show.value=true
  //   getImg();
  // })
  if(props.isCrop){
    fileToBase64(file.file).then(res => {
      console.log(res)
      show.value = true;
      cutImgUrl.value = "data:image/png;base64," + res;
      getImg();
    })
  }else{
    let formData = new FormData();
    formData.append('file', file.file);
    weChatUploadApi.uploadFile(formData).then(res=>{
      console.log(res)
      emit('getImgList',props.list.concat(CONFIG.imgURL+res.data.filepath));
    })
  }


};
const fileToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    // 创建一个新的 FileReader 对象
    const reader = new FileReader();
    // 读取 File 对象
    reader.readAsDataURL(file);
    // 加载完成后
    reader.onload = function () {
      // 将读取的数据转换为 base64 编码的字符串
      const base64String = reader.result.split(",")[1];
      // 解析为 Promise 对象，并返回 base64 编码的字符串
      resolve(base64String);
    };

    // 加载失败时
    reader.onerror = function () {
      reject(new Error("Failed to load file"));
    };
  });
}
let cropper;
let imgRef = ref();
const getImg = () => {
  nextTick(() => {
    // const image = imgRef.value;
    cropper = new Cropper(imgRef.value, {
      aspectRatio: props.aspectRatio,
      dragNode: 'move',
      initialAspectRatio: 1,
      minCropBoxWidth: 300,
      // aspectRatio:1,
      // cropBoxResizable:true,
      // background: false,
      // autoCropArea: 0.6,
      // zoomOnWheel: false,
      crop(event) {
        console.log(event.detail.x);
        console.log(event.detail.y);
        console.log(event.detail.width);
        console.log(event.detail.height);
        console.log(event.detail.rotate);
        console.log(event.detail.scaleX);
        console.log(event.detail.scaleY);
      },
    });
  })
}


const beforedelete = (file: any, idx: any) => {
  console.log(file, idx, fileList.value, idx.index)
  fileList.value.splice(idx.index, 1);
  let l = [];
  for (let i in fileList.value) {
    l.push(fileList.value[i].url)
  }
  emit('getImgList', l);
  return true
}
const html = ref();

const loading=ref(false);
//裁剪图片
const cutImg = () => {
  loading.value=true;
  console.log('裁剪')
  html.value = cropper.getCroppedCanvas().toDataURL('image/png')

  var bytes = window.atob(html.value.split(',')[1]);

  var array = [];
  for (var i = 0; i < bytes.length; i++) {
    array.push(bytes.charCodeAt(i));
  }
  var blob = new Blob([new Uint8Array(array)], {type: 'image/jpeg'});

  let formData = new FormData();
  formData.append('file', blob, Date.now() + '.jpg');
  console.log(formData.get('file'))
  weChatUploadApi.uploadFile(formData).then(res => {
    console.log(res)
    if(res.data?.filepath)
    emit('getImgList', props.list.concat(CONFIG.imgURL + res.data.filepath));
    else {
      showToast({
        message:'图片上传失败'
      });
    }
    show.value = false;
    cropper.destroy();
  }).finally(()=>{
    loading.value=false;
  })
}


return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_uploader, {
      modelValue: fileList.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      disabled: _ctx.disabled,
      deletable: !_ctx.disabled,
      "image-fit": "contain",
      "max-count": _ctx.count,
      "after-read": afterRead,
      "before-delete": beforedelete,
      accept: "image/*"
    }, null, 8, ["modelValue", "disabled", "deletable", "max-count"]),
    _createVNode(_component_van_overlay, {
      show: show.value,
      "z-index": "150"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          ref_key: "imgRef",
          ref: imgRef,
          src: cutImgUrl.value
        }, null, 8, _hoisted_1),
        _createElementVNode("div", { class: "btn-area" }, [
          _createElementVNode("div", {
            class: "btn",
            onClick: cutImg
          }, "确认裁剪")
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})